export default "/_next/static/7f3977c2bb65b26aecaa27aeb0e33a0d.png";